<template>
  <div class="news-briefed p-10">
    <!-- <div class="editor-content" v-html="content" /> -->
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" size="medium" @click.native="() => edit()">添加</el-button>
      </div>
      <div class="search-group">
        <el-input
          placeholder="标题关键词"
          v-model.trim="searchFormData.title"
          @keypress.enter.native="search"
        />
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
      >
        <template v-slot:is_use="row">{{row.is_use ? '是' : '否'}}</template>
        <template v-slot:is_show="row">{{row.is_use ? '是' : '否'}}</template>
        <template v-slot:action="row">
          <el-button @click="edit(row)" type="text" size="mini">修改</el-button>
          <el-button @click="del(row)" type="text" class="el-button--danger" size="mini">删除</el-button>
        </template>
      </ly-table>
    </div>
  </div>
</template>

<script>
import { Input } from 'element-ui';
import { frontInf } from '@/api';
import LyTable from '@/components/LyTable';
import { briefedTable } from '@/utils/tableHeader';

export default {
  name: 'NewsBriefed',
  components: {
    LyTable,
    ElInput: Input
  },
  data() {
    return {
      searchFormData: {
        title: ''
      },
      defaultFormItem: {},
      tableHeader: briefedTable,
      getTableData: frontInf.getInformation,
      isAdd: false,
      baseUrl: '',
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    edit(row) {
      this.$router.push(`/${this.$route.params.user_id}/news/briefed/${row ? row.id : -1}`);
    },
    del(row) {
      this.$confirm('永久删除该条信息, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          frontInf
            .controlInformation({
              id: row.id,
              methold: 'DELETE'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less">
.news-briefed {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
</style>
